module.exports = __webpack_public_path__ + "97d2c68c21a5f1754cf11d1f40c80fa8.jpg";